import { Modal } from "react-bootstrap"
import React, { useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from "react-responsive-carousel"

function AttachmentModal(props) {
  const [selectedImg, setSelectedImg] = useState(props.selected)

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  function handleClickImage(index) {
    setSelectedImg(index)
  }

  useEffect(() => {
    if (props.show) {
      setSelectedImg(props.selected)
    }
  }, [props.show, props.selected])

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        centered
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <div className="p-2">
          <div onClick={props.onHide} className="exit-button w-full text-end">
            <CloseIcon />
          </div>
          <div className="d-flex flex-column flex-sm-row gap-4">
            <div className="w-full p-2">
              <Carousel
                responsive={responsive}
                showThumbs={false}
                selectedItem={selectedImg}
                onChange={(index) => setSelectedImg(index)}
              >
                {props.images.map((image, index) => (
                  <div
                    key={index}
                    className="w-full h-full d-flex align-items-center"
                  >
                    <img src={image.file_url} alt={`Slide ${index + 1}`} />
                  </div>
                ))}
              </Carousel>
            </div>
            <div className="w-full mt-2">
              <p className="mb-1 print-data">FILE ATTACHMENTS</p>
              <div className="overflow-scroll">
                {props.images.map((image, index) => (
                  <div
                    key={index}
                    className={`image-item ${
                      selectedImg === index ? "image-item-selected" : ""
                    }`}
                    onClick={() => handleClickImage(index)}
                  >
                    <p className="m-0">{image.file_name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

AttachmentModal.defaultProps = {
  title: "",
  size: "xl",
  images: [],
  show: () => {},
  onHide: () => {},
  selected: 0, // default to the first slide
}

export default AttachmentModal
